/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import AuthPiece from "aws-amplify-react/lib/Auth/AuthPiece";
import { AuthShell } from "./AuthFormShared";
import { AuthLoadingFormView } from "./AuthFormViews";

const AuthPieceBase: any = AuthPiece;

export class AuthLoading extends AuthPieceBase {
    constructor(props: any) {
        super(props);
        this._validAuthStates = ["loading"];
    }

    showComponent = () => (
        <AuthShell showMobileIllustration={false} title="Loading Treez">
            <AuthLoadingFormView />
        </AuthShell>
    );
}

export default AuthLoading;
